import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import type { App } from 'vue'

const firebaseConfig = {
  apiKey: "AIzaSyA9ITkVxu-9i9t_7deCMURYdUbO1GVI9w4",
  authDomain: "fineshare-ddf44.firebaseapp.com",
  projectId: "fineshare-ddf44",
  storageBucket: "fineshare-ddf44.firebasestorage.app",
  messagingSenderId: "591546354221",
  appId: "1:591546354221:web:dc6f2767ff50406386c6a4",
  measurementId: "G-B71EZEJ988"
}

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)

export default {
  install(app: App) {
    app.config.globalProperties.$firebaseAuth = auth
    app.provide('firebaseAuth', auth)
  }
}

export { auth }
